import { geturl, geturltime, posturl } from "./ajax";
import { getUSER, setUSER, getGUID, setGUID, $STORE, checkUSER } from "./auth";

// 获取url参数
function getQueryVariable(variable) {
  var query = window.location.href.replace(/[\?#]/g, "&");
  // alert(window.location.href);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

// 用于全局路由
// 通过不同的来源做判断
export const LoadRouter = router => {
  //document.title = "报价系统";
  // 全局钩子，判断是否登录
  router.beforeEach((to, from, next) => {
    let source = getQueryVariable("fromty") || "";

    let wxopenid = sessionStorage.getItem("wxopenid") || "";
    let qqopenid = sessionStorage.getItem("qqopenid") || "";
    let flag = getQueryVariable("flag") || "";

    //如果是flag == PAY，首页直接隐藏
    sessionStorage.setItem("__flag__", flag);

    // 代表是第一次访问还是非第一次
    let laiyuan = sessionStorage.getItem("laiyuan") || "";

    //先判断是否有防止进入报价首页的标识,如果存在则直接重定向
    let banIndexPage = sessionStorage.getItem("banIndex") || "";
    if (banIndexPage != "") {
      window.location.href = banIndexPage;
      //next("/pay");
      return;
    }

    //如果是确认稿页 直接进入
    if (to.path == "/confirm" || to.path == "/fahuoview") {
      next();
      return;
    }

    // //如果是支付界面，不需要让客户关注我们系统
    // if (flag == "PAY" && !sessionStorage.getItem("PAY")) {
    //   sessionStorage.setItem("PAY", "out");
    //   sessionStorage.setItem("PAY_DH", getQueryVariable("DH"));
    //   next("/pay");
    //   return;
    // }
    // alert("browser:" + sessionStorage.getItem("browser"));
    // alert("flag:" + flag);
    if (
      sessionStorage.getItem("browser") == "W01" &&
      sessionStorage.getItem("PAY")
    ) {
      next();
      return;
    }
    if (
      flag == "PAY" &&
      sessionStorage.getItem("browser") != "W01" &&
      !sessionStorage.getItem("PAY")
    ) {
      sessionStorage.setItem("PAY", "out");
      sessionStorage.setItem("PAY_DH", getQueryVariable("DH"));
      sessionStorage.setItem("PAY_DZ", getQueryVariable("DZ"));
      next("/pay");
      return;
    }
    // // 如果来源是微信，本地openid有不存在，应该重新拉取用户信息
    // if (browser == "W01") {
    //   sessionStorage.setItem("laiyuan", "wx");
    // } else {
    //   // 代表第一次进入系统，非微信进入
    //   if (laiyuan == "") {
    //     if (source == "1") {
    //       // 设置为qq客户
    //       sessionStorage.setItem("laiyuan", "qqkehu");
    //     } else if (source == "2") {
    //       // 设置为qq客服
    //       sessionStorage.setItem("laiyuan", "qqkefu");
    //       // next('/qidianqqB')
    //     } else {
    //       // pc或者其他wap移动端
    //       sessionStorage.setItem("laiyuan", "pc");
    //       // next()
    //     }
    //   }
    // }

    // 重新获取来源
    laiyuan = sessionStorage.getItem("laiyuan") || "";
    //console.log(laiyuan)
    if (laiyuan == "wx") {
      // 如果是来之微信，判断是否本地有openid，如果存在，就不用再去拉取用户信息，如果不存在，需要跳转到微信服务器拉取信息

      //alert(wxopenid);

      if (wxopenid == "") {
        let code = getQueryVariable("code") || "";

        //alert(code);

        if (code != "") {
          //提交到服务器，拉取信息
          geturl("/api/wx/getopenid", {
            code: code,
            scope_type: sessionStorage.getItem("scope_type")
          }).then(x => {
            if (x.data.success) {
              // 这个用于后面判断
              sessionStorage.setItem("laiyuan", "wx");
              // 没有账户的时候，要求绑定账户
              sessionStorage.setItem("wxopenid", x.data.data.openid);

              //sessionStorage.setItem("PK",getQueryVariable("PK"));

              //这里已经得到了OPENID
              //如果是支付界面，不需要让客户关注我们系统
              if (sessionStorage.getItem("scope_type") == "snsapi_base") {
                sessionStorage.setItem("PAY", "out");
                next("/pay");
                return;
              }

              if (getQueryVariable("toUrl")) {
                //需要跳转的地址
                sessionStorage.setItem(
                  "toUrl",
                  unescape(getQueryVariable("toUrl"))
                );
              }

              if (x.data.data.type == "ok") {
                // 代表可以直接登录
                setUSER(x.data.data.token);
                // 代表微信登录成功，但是需要绑定手机号
                //alert(3);
                if (!x.data.data.token.Account) {
                  //需要跳转的地址
                  //sessionStorage.setItem("wxto", to.fullPath);
                  next("/wxbangding");
                } else {
                  // 代表成功，直接跳转到微信首页
                  //应该跳转到原始确认页面
                  next("/shouye");
                }
              }

              // 如果是微信没有关注，要求用户关注
              if (x.data.data.type == "guanzhu") {
                // 没有关注，需要跳转到关注界面
                // 存储微信关注的二维码
                sessionStorage.setItem("wxguanzhuimage", x.data.data.token);
                // 跳转到关注界面
                next("/wxguanzhu");
              }
            } else {
              //拉取失败,跳转到首页
              location.href = "/";
            }
          });
        } else {
          // 如果不同意，强制要求用户同意授权
          // 拉取openid
          //默认是非静默授权
          let scope_type = "snsapi_userinfo";
          //只有支付的时候才走静默授权
          if (flag == "PAY") {
            scope_type = "snsapi_base";

            sessionStorage.setItem("PAY_DH", getQueryVariable("DH"));
            sessionStorage.setItem("PAY_DZ", getQueryVariable("DZ"));
          }

          sessionStorage.setItem("scope_type", scope_type);
          geturl("/api/wx/getappid").then(x => {
            if (x.data.success) {
              let local = window.location.href;

              window.location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                x.data.data +
                "&redirect_uri=" +
                encodeURIComponent(local) +
                "&response_type=code&scope=" +
                scope_type +
                "&state=1#wechat_redirect";
            }
          });
        }
      } else {
        // 正常浏览
        //alert(4);
        if (to.path == "/") {
          next("/shouye");
        } else {
          next();
        }
        // next();
      }
    }

    // 下面具体判断
    if (laiyuan == "qqkehu") {
      // openid
      var openid = getQueryVariable("openid") || "";
      if (openid == "") {
        //代表是错误的，直接路由过去得了
        next("/error");
        return;
      }
      if (qqopenid == "") {
        // 通过qqopenid获取用户的是否绑定
        geturl("/api/qq/getopenid", { openid: openid }).then(x => {
          // console.log(x)
          if (x.data.success) {
            if (x.data.data.type == "ok") {
              // 代表可以直接登录
              setUSER(x.data.data.token);
              sessionStorage.setItem("qqopenid", openid);
              // 代表微信登录成功，但是需要绑定手机号
              if (to.path == "/upload") {
                next();
              } else if (!x.data.data.token.Account) {
                // 绑定手机号
                next("/qqbangding");
              } else {
                // 代表成功，直接跳转到微信首页
                next("/shouye");
              }
            }
          } else {
            next("/error");
            return;
          }
        });
      } else {
        next();
      }
    }

    if (laiyuan == "qqkefu") {
      // openid
      var corpUser = getQueryVariable("corpUser"); //员工编号
      var qqUser = getQueryVariable("qqUser"); //聊天的客户编号

      if (qqUser == "") {
        //代表是错误的，直接路由过去得了
        next("/error");
        return;
      }

      // alert(corpUser)
      if (qqopenid == "") {
        // 通过qqopenid获取用户的是否绑定
        geturl("/api/qq/getopenid", { openid: qqUser }).then(x => {
          if (x.data.success) {
            // 代表可以直接登录
            setUSER(x.data.data.token);
            // sessionStorage.setItem("qqopenid", openid);
            sessionStorage.setItem("qqopenid", qqUser);
            // 通过客服openid，获取客服信息存储本地
            geturl("/api/qq/getkefu", {
              openid: corpUser,
              qquser: qqUser
            }).then(ret => {
              if (ret.data.success) {
                // 存储客服信息
                sessionStorage.setItem("corpUser", corpUser);
                sessionStorage.setItem("corpUserid", ret.data.data.userid);
                // 代表客服人员已经绑定
                if (ret.data.data.type == "ok") {
                  // 代表成功，直接跳转到微信首页
                  next("/qidianqqB");
                } else {
                  // 绑定客服人员
                  next("/qqkfbangding");
                }
              }
            });
          } else {
            next("/error");
            return;
          }
        });
      } else {
        next();
      }
    }

    if (laiyuan == "pc") {
      //console.log(laiyuan);
      if (to.path == "/index" && sessionStorage.getItem("daohang")) {
        let menupath = sessionStorage.getItem("daohang") || "";

        next(menupath);
      } else {
        next();
      }
    }

    //禁止 shouye 返回上一层
    // let allowBack = true; //    给个默认值true
    // if (to.meta.allowBack !== undefined) {
    //   allowBack = to.meta.allowBack;
    // }
    // if (!allowBack) {
    //   history.pushState(null, null, location.href);
    // }
    // store.dispatch("updateAppSetting", {
    //   allowBack: allowBack
    // });
  });

  router.afterEach(to => {
    // 设置title
    //if (to.meta && to.meta.title) document.title = to.meta.title;
    //else document.title = `${$STORE.state.Title}自助报价`;
    if (isMobile()) document.title = "自助报价";
    else document.title = `${$STORE.state.Title}自助报价`;
  });
};



// WEBPACK FOOTER //
// ./src/main-router.js